// 역검증이 고른 질문을 화면에 어떻게 보여줄지 — 축 이름ㆍ가르는 후보 수ㆍ문언 출처ㆍ그 호 자신의
// 갈림 질문. 질문은 후보를 가르는 축으로 고르고 문언은 그 축을 다루는 공식 프레임에서 오므로,
// 사용자가 보고 있는 호와 다른 호의 말로 물을 수 있다. 그래서 문맥을 함께 보여 준다.

/** fact key → 사용자에게 보일 축 이름. 없는 키는 화면에 쓰지 않는다(기계어 노출 금지). */
const AXIS_LABELS = {
  material_base: "재질",
  construction: "편성",
  shape_form: "형태",
  processing_degree: "가공 정도",
  surface_treatment: "표면 처리",
  use: "용도",
  article_character: "물품 성격",
};

export function questionContext(rv) {
  const question = rv && typeof rv.next_question === "string" ? rv.next_question.trim() : "";
  if (!question) return null;

  const selection = (rv && rv.question_selection) || {};
  // 부위 수식(material_base@upper)은 벗겨서 축 이름을 찾는다 — 묻는 축은 재질이다.
  const factKey = typeof selection.fact_key === "string" ? selection.fact_key.split("@")[0] : "";
  const axis = AXIS_LABELS[factKey] || null;
  const splits = Array.isArray(selection.splits) ? selection.splits : [];
  const context = typeof selection.context === "string" ? selection.context.trim() : "";

  return {
    question,
    axis,
    splitCount: splits.length,
    wordingFrom: selection.wording_from || null,
    // 같은 문장을 두 번 보여 주지 않는다.
    context: context && context !== question ? context : null,
  };
}
